import { useEffect, useState } from 'react';

/**
 * Delays reflecting `value` until it has stopped changing for `delayMs` --
 * used to debounce the search page's input so every keystroke doesn't
 * fire its own request/URL update. Mirrors
 * `apps/web/src/features/admin/lib/use-debounced-value.ts` exactly, kept
 * as a separate copy rather than imported from there since the
 * storefront must not import from `features/admin` (see
 * `apps/web/src/lib/format.ts`'s note on `formatPaise`).
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
